import React, { useReducer, useContext } from "react";
import { teamReducer as reducer } from "../reducers/teamReducer";
import { teamActions as actions } from "../actions/teamActions";

const teamContext = React.createContext();

const TeamContext = ({ enterpriseId, children }) => {
  const initialValue = {
    teams: null,
    enterpriseId: enterpriseId,
  };

  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <teamContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </teamContext.Provider>
  );
};

export const useTeamContext = () => React.useContext(teamContext);
export default TeamContext;
